export interface ISetting {
  id: string;
  settingTypeModel: SettingType;
  value: string;
  isCreating: boolean;
  key: string;
}

export enum SettingType {
  User = 0,
  System,
  Integration,
}

export const settingList = {
  settings: [] as ISetting[],
  searchString: "",
  searchType: undefined as SettingType | undefined,
};

export const globalSettings = {
  chatOptions: {
    slNoColorSeconds: 0,
    slYellowSeconds: 0,
    slRedSeconds: 0,
    closeChatCategories: "",
    mapProvider: 1,
  },
  operatorOptions: {
    disconnectionTimeout: 0,
    pauseCategories: "",
    showHintsFromAllOperators: false,
  },
  commonOptions: {
    locale: ''
  }
};

export type ISettingList = typeof settingList;
export type IGlobalSettings = typeof globalSettings;
